module.exports = __webpack_public_path__ + "static/media/err_reflejo_1.66b3b5a9.png";